import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=dc2f9806&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=dc2f9806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2f9806",
  null
  
)

export default component.exports